import type { CardDef } from '../../../../core/card';
import { cardName } from '../../../../core/cardText';

/**
 * 把 `card.name` 拆成两个标题。
 *
 * `card.name` 现在是 `"Exception 异常"` 这样的一坨 —— 中英文挤在一起，
 * 两边都不好排版。设计上要的是**中文当主标题、英文降级成机读小字**
 * （`visual-design.md` §12 决策 2）。
 *
 * ⚠️ 拆标题是**显示层的活**：逻辑层不许读 `name`，这里正是它该被读的地方。
 */

const LATIN = /[A-Za-z][A-Za-z0-9_:-]*/g;

/** `"Exception 异常"` → `"EXCEPTION"`。抽不出拉丁词就退回 `local` */
export function latinTitle(card: CardDef): string {
  const m = LATIN.exec(cardName(card));
  LATIN.lastIndex = 0;
  return (m?.[0] ?? card.local).toUpperCase();
}

/** `"Exception 异常"` → `"异常"`。整个名字都是拉丁文就原样返回 */
export function cjkTitle(card: CardDef): string {
  const rest = cardName(card).replace(LATIN, ' ').replace(/\s+/g, ' ').trim();
  LATIN.lastIndex = 0;
  return rest === '' ? cardName(card) : rest;
}
